var DynamicCertificateFormParserModule = /** @class */ (function () {
    function DynamicCertificateFormParserModule() {
    }
    return DynamicCertificateFormParserModule;
}());
export { DynamicCertificateFormParserModule };
